export enum RecoveryType {
  PASSPORT,
  PASSWORD
}
